import { FC } from 'react';

import { ShopModal, ShopPage } from './components';
import { getMod } from 'services/hooks';

export const Shop: FC = () => {
  const CharityShop = getMod('charityHobby')?.screens.CharityShop;

  if (CharityShop) {
    return <CharityShop />;
  }

  return (
    <>
      <ShopPage />
      <ShopModal />
    </>
  );
};
